import { MESSAGECONSTANTS } from 'src/app/core/utils/constants';
class EmailDocumentsController {
    /*@ngInject*/
    constructor($rootScope, $timeout, $uibModal, modalService, documentService, alertsAndNotificationsService, documentActionService, userService, jobMatchService, sharedAjsService, llmIntegrationService) {
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.$timeout = $timeout;
        this.modalService = modalService;
        this.documentService = documentService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.documentActionService = documentActionService;
        this.userService = userService;
        this.jobMatchService = jobMatchService;
        this.sharedAjsService = sharedAjsService;
        this.llmIntegrationService = llmIntegrationService;
    }
    $onInit() {
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.userId = this.$rootScope.userDetails.id;
        this.loggedIdCompanyName = this.$rootScope.userDetails.company.companyName;
        this.loggedInUserName = this.$rootScope.userDetails.firstname + " " + this.$rootScope.userDetails.lastname;
        this.isStaffingCompany = this.$rootScope.userDetails.company.companyType === 'StaffingCompany';
        this.loggedInUserEmailId = this.$rootScope.userDetails.emailId;
        this.attachedDocuments = [];
        this.documentsSectionHtml = '';
        this.availableDocuments = [];
        this.selectedEmailSendToObjectsArray = [];
        this.selectedEmailCCObjectsArray = [];
        this.selectedEmailBCCObjectsArray = [];
        this.defaultCandidateEmail = null;
        this.userSearchPlaceholder = 'Type email to search.';
        this.emailDocumentFolderId = null;
        this.selectedJobMatchList = [];
        this.candidateAssessmentFiles = [];
        this.candidateInformationList = [];
        this.addedEmailCount = 0;
        this.savingFlag = false;
        this.isRequisitionUsersSelected = true;
        this.emailDetails = {
            documentIds: [],
            emailUsers: [],
            subject: "",
            ccUsers: [],
            bccUsers: [],
            body: ""
        };
        this.searchUsersForEmail = null;
        let defaultLoggedInUserEmail = {
            id: this.userId,
            email: this.loggedInUserEmailId,
            displayString: "",
            name: `${this.loggedInUserName}`,
            isCompanyUser: this.isStaffingCompany
        };
        if (this.candidateDetails && this.candidateDetails.candidateEmail) {
            this.emailDetails.emailUsers.push({ email: this.candidateDetails.candidateEmail });
            this.defaultCandidateEmail = {
                id: this.candidateDetails.candidateId,
                email: this.candidateDetails.candidateEmail,
                displayString: "",
                name: `${this.candidateDetails.candidateEmail}`
            };
            this.selectedEmailSendToObjectsArray.push(this.defaultCandidateEmail);
            // Add Logged in user to cc list
            this.emailDetails.ccUsers.push({ email: this.loggedInUserEmailId });
            this.selectedEmailCCObjectsArray.push(defaultLoggedInUserEmail);
        }
        else {
            this.emailDetails.ccUsers.push({ email: this.loggedInUserEmailId });
            this.selectedEmailCCObjectsArray.push(defaultLoggedInUserEmail);
        }
        if (this.candidateDetails) {
            this.candidateId = this.candidateDetails.candidateId;
            this.jobMatchId = this.candidateDetails.jobMatchId;
            if (this.candidateDetails.candidateEmailSubjectAndBodyInformation) {
                this.emailDetails.subject = this.candidateDetails.candidateEmailSubjectAndBodyInformation.subject;
                this._setEmailBodyPrePopulatedInformation(null);
                this.candidateInformationList = _.cloneDeep(this.candidateDetails.candidateEmailSubjectAndBodyInformation.candidateInfoInEmailBody);
            }
        }
        if (this.candidateDetails && !this.candidateId && this.document) {
            this.candidateId = this.document.candidateId;
        }
        if (this.documents && this.document) {
            this.availableDocuments = this.documents;
            this.attachedDocuments = this.documents.filter(doc => doc.id === this.document.id);
            this.attachedDocuments.forEach(doc => {
                doc.selected = true;
            });
        }
        this.uploadEmailDocumentResponse = null;
        this.fileUploadInProgressFlag = false;
        this.disableUploadButtonFlag = false;
        this.isAttachDocuments = false;
        this.isCandidateJobMatch = false;
        this.isExistingDocumentsAvailable = false;
        this.isPrePopulatedUsersAvailable = false;
        this.showClientForReviewCheckbox = false;
        this.selectAllCandidates = false;
        this.selectAllCandidatesExternal = false;
        this.externalCandidateAction = null;
        this.isSendForReviewSelected = false;
        this.selectedCandidateFieldsForReview = [];
        if (!this.folders && !this.candidateJobMatchFolders) {
            // Pre populate users in candidate workflow
            if (this.candidateDetails.context == 'candidateJobMatchCard') {
                // Set Email CC,BCC,CC Search
                this.candidateJobMatchFolders = [];
                this._setUserToEmailSearchObject();
                this._setPrePopulatedEmailUsersList(this.candidateDetails.jobMatchId);
            }
            this.getAllCandidateFolders(null, () => { });
        }
        else {
            // From candidate documents to email
            // Pre populate users in candidate workflow
            if (this.candidateDetails.context == 'candidateJobMatchCard') {
                if (this.candidateDetails.jobMatchId) {
                    this.candidateJobMatchFolders = this.candidateJobMatchFolders.filter(jobMatch => this.candidateDetails.jobMatchId == jobMatch.jobMatch.jobMatchId);
                    this._setPrePopulatedEmailUsersList(this.candidateDetails.jobMatchId);
                }
            }
            else {
                // Pre populate users in candidate card
                this._setPrePopulatedEmailUsersList();
            }
            this.isExistingDocumentsAvailable = true;
            this._setUserToEmailSearchObject();
            this.isPrePopulatedUsersAvailable = true;
        }
        //initialize the drop zone configuration
        this.$timeout(() => {
            this.emailDocumentUploadDropzone = this.createEmailDocumentUploadDropZone();
        }, 200);
        // Initialize height adjustment for attached documents section
        this.$timeout(() => {
            this.adjustAttachedDocumentsHeight();
        }, 300);
        this._setCandidateAssessmentReports();
        this.inputTypeAheadText = {
            emailUsers: '',
            ccUsers: '',
            bccUsers: ''
        };
        // this._setCandidateInformationInBody();
        this._handleFilterDisplay();
        // store original signature (if any) so we can re-append after formalization
        this._emailSignature = this.emailDetails.body || '';
    }
    // Receive formalized email content from downgraded FormalizeComment component
    receiveFormalizedEmail(output) {
        if (!output)
            return;
        if (output.subject) {
            this.emailDetails.subject = output.subject;
        }
        if (output.body) {
            if (output.isHtml) {
                this.emailDetails.body = output.body + (this._emailSignature || '');
                this.displayedBody = this.emailDetails.body;
            }
            else {
                // Legacy plain-text path: wrap in <p> tags and re-attach signature.
                let bodyPlain = output.body.toString().trim();
                // Remove pre-populated signature (if present) from the formalized output.
                let signatureHtml = this._emailSignature || '';
                let signatureText = signatureHtml.replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim();
                if (signatureText) {
                    let bodyLower = bodyPlain.toLowerCase();
                    let sigLower = signatureText.toLowerCase();
                    if (bodyLower.endsWith(sigLower)) {
                        bodyPlain = bodyPlain.slice(0, bodyPlain.length - signatureText.length).trim();
                    }
                    else {
                        let idx = bodyLower.lastIndexOf(sigLower);
                        if (idx !== -1) {
                            bodyPlain = bodyPlain.slice(0, idx).trim();
                        }
                    }
                }
                const htmlBody = bodyPlain.split(/\n{1,}/).map(p => `<p>${p.trim()}</p>`).join('');
                this.emailDetails.body = htmlBody + (this._emailSignature || '');
                this.displayedBody = this.emailDetails.body;
            }
        }
        this.alertsAndNotificationsService.showBannerMessage('Email content enhanced by AI.', 'success');
    }
    /**
     * creates the email upload drop zone.
     */
    createEmailDocumentUploadDropZone() {
        let dropZoneSettings = this._getDropZoneSettings();
        let emailDocumentUploadDropzone = new Dropzone("form#emailDocumentUploadDropzone", dropZoneSettings);
        // add event handlers for the drop zone
        emailDocumentUploadDropzone.on('addedfile', (file, response) => {
            this.fileUploadInProgressFlag = true;
            this.disableUploadButtonFlag = true;
            if (file) {
                $(".dz-preview").remove();
                this.uploadEmailDocumentToUpload();
            }
        });
        emailDocumentUploadDropzone.on('removedfile', (file, response) => { });
        emailDocumentUploadDropzone.on('sendingmultiple', (file, xhr, formData) => {
            formData.append('companyId', this.companyId);
            formData.append('candidateId', this.candidateId);
            formData.append('internalNote', "");
            formData.append('sharedEntityIds', null);
            formData.append('shareDocument', false);
            formData.append('folderId', this.emailDocumentFolderId);
            formData.append('candidateType', this.candidateDetails.candidateType);
            formData.append('userId', this.userId);
        });
        emailDocumentUploadDropzone.on('successmultiple', (fileArray, response) => {
            // remove file upload in progress flag
            this.uploadEmailDocumentResponse = response;
            if (response) {
                this._setAttachedDocuments(response);
            }
            else {
                this.fileUploadInProgressFlag = false;
                this.disableUploadButtonFlag = false;
            }
            this.alertsAndNotificationsService.showBannerMessage("Document(s) added successfully.", "success");
        });
        emailDocumentUploadDropzone.on("complete", (file) => {
            emailDocumentUploadDropzone.removeAllFiles();
        });
        emailDocumentUploadDropzone.on("error", (file, error) => {
            this.fileUploadInProgressFlag = false;
            let errorMessage = error.message ? error.message : error;
            this.alertsAndNotificationsService.showBannerMessage(errorMessage, "error");
            this.fileUploadInProgressFlag = false;
            this.disableUploadButtonFlag = false;
        });
        return emailDocumentUploadDropzone;
    }
    _getDropZoneSettings() {
        let dropZoneSettings = {};
        let maxFilesToUpload = 2;
        dropZoneSettings = {
            url: this.documentService.getUploadUrl(),
            paramName: () => {
                return "files";
            },
            acceptedFiles: ".pdf,.xlsx,.docx,.doc",
            maxFiles: maxFilesToUpload,
            maxFilesize: 10,
            maxThumbnailFilesize: 10,
            timeout: 300000,
            addRemoveLinks: true,
            autoProcessQueue: false,
            uploadMultiple: true,
            parallelUploads: 100
        };
        return dropZoneSettings;
    }
    _buildDocumentsSectionHtml() {
        const selectedAssessments = (this.candidateAssessmentFiles || []).filter(f => f.isSelected);
        const hasAttached = this.attachedDocuments && this.attachedDocuments.length > 0;
        if (!hasAttached && selectedAssessments.length === 0) {
            this.documentsSectionHtml = '';
            return;
        }
        let html = '<p id="doc-attach-header"><b>Document(s) attached:-</b></p>';
        selectedAssessments.forEach(file => {
            html += `<p><b>${file.name}:</b> ${file.resumeNameOrXrXml}</p>`;
        });
        if (hasAttached) {
            this.attachedDocuments.forEach(doc => {
                if (doc.isJobMatchDocument) {
                    // Use displayLabel and displayFileName from document object
                    const displayLabel = doc.displayLabel || doc.fileName;
                    const displayFileName = doc.displayFileName || doc.fileName;
                    html += `<p><b>${displayLabel}:</b> ${displayFileName}</p>`;
                }
                else {
                    const label = this._getDocumentLabel(doc);
                    if (label) {
                        html += `<p><b>${label}:</b> ${doc.fileName}</p>`;
                    }
                    else {
                        html += `<p><b>${doc.fileName}</b></p>`;
                    }
                }
            });
        }
        html += '<p><br/></p>';
        this.documentsSectionHtml = html;
    }
    onAssessmentFileChange() {
        this._buildDocumentsSectionHtml();
    }
    _getDocumentLabel(doc) {
        if (doc.folderId && this.folders) {
            for (const folder of this.folders) {
                if (folder.id === doc.folderId) {
                    if (folder.name === 'Resume')
                        return 'Resume';
                    if (folder.name === 'Technical Assessment')
                        return 'Technical Assessment';
                    return null;
                }
                if (folder.folders) {
                    for (const subFolder of folder.folders) {
                        if (subFolder.id === doc.folderId) {
                            if (subFolder.name === 'Resume')
                                return 'Resume';
                            if (subFolder.name === 'Technical Assessment')
                                return 'Technical Assessment';
                            if (folder.name === 'Resume')
                                return 'Resume';
                            if (folder.name === 'Technical Assessment')
                                return 'Technical Assessment';
                            return null;
                        }
                    }
                }
            }
        }
        return null;
    }
    _setAttachedDocuments(response) {
        this.getAllCandidateFolders(response, () => {
            this.fileUploadInProgressFlag = false;
            this.disableUploadButtonFlag = false;
        });
    }
    attachDocument(document) {
        let checkIfDocExists = false;
        this.attachedDocuments.every(doc => {
            if (doc.id === document.id) {
                checkIfDocExists = true;
                return false;
            }
            return true;
        });
        if (!checkIfDocExists) {
            this.attachedDocuments.push(document);
            this._buildDocumentsSectionHtml();
        }
    }
    detachDocument(document) {
        this.attachedDocuments = this.attachedDocuments.filter(doc => doc.id !== document.id);
        this._buildDocumentsSectionHtml();
    }
    _setJobMatchSelectedDocumentObj(jobMatchDocument) {
        let tempObj = {
            jobId: jobMatchDocument.jobMatch.jobId,
            jobMatchTitle: jobMatchDocument.jobMatch.jobMatchTitle,
            jobMatchRequisitionNum: jobMatchDocument.jobMatch.jobMatchRequisitionNum,
            jobMatchId: jobMatchDocument.jobMatch.jobMatchId,
            testInvitationId: null,
            sendRecruiterScreeningFeedbackReport: false,
            sendPhoneScreeningFeedbackReport: false,
            sendInterviewFeedbackReport: false,
            sendTechAssessmentReport: false,
            sendOutreachFeedbackReport: false
        };
        switch (jobMatchDocument.fileName) {
            case 'Tech Assessment':
                tempObj.testInvitationId = jobMatchDocument.jobMatch.techAssessmentInvitationId;
                tempObj.sendTechAssessmentReport = true;
                break;
            case 'Value Assessment':
                tempObj.valueAssessmentInvitationId = jobMatchDocument.jobMatch.valueAssessmentInvitationId;
                tempObj.sendValueAssessmentReport = true;
                break;
            case 'Recruiter Screening Feedback':
                tempObj.sendRecruiterScreeningFeedbackReport = true;
                break;
            case 'Phone Screen Feedback':
                tempObj.sendPhoneScreeningFeedbackReport = true;
                break;
            case 'Interview Feedback':
                tempObj.sendInterviewFeedbackReport = true;
                break;
            case 'Outreach Feedback':
                tempObj.sendOutreachFeedbackReport = true;
                break;
            default:
                break;
        }
        return tempObj;
    }
    _setCandidateDocumentsToEmail() {
        let candidateDocuments = [];
        let allFolders = [];
        this.folders.map(parentFolder => {
            allFolders.push(parentFolder);
            if (parentFolder.folders && parentFolder.folders.length > 0) {
                parentFolder.folders.map(childFolder => allFolders.push(childFolder));
            }
        });
        this.attachedDocuments.map(document => {
            if (!document.isJobMatchDocument) {
                let tempDocument = {};
                tempDocument.documentId = document.id;
                tempDocument.documentName = document.fileName;
                tempDocument.folderId = document.folderId;
                this.documentActionService.setParentAndChildFolderName(allFolders, tempDocument);
                candidateDocuments.push(tempDocument);
            }
        });
        return candidateDocuments;
    }
    _setJobMatchesDocumentsToEmail() {
        let selectedJobMatchDocuments = this.attachedDocuments.filter(doc => doc.isJobMatchDocument);
        let emailJobMatchObjList = [];
        if (selectedJobMatchDocuments.length > 0) {
            selectedJobMatchDocuments.map(jobMatchDocument => {
                emailJobMatchObjList.push(this._setJobMatchSelectedDocumentObj(jobMatchDocument));
            });
        }
        return emailJobMatchObjList;
    }
    _setCandidateResumesToEmail(type) {
        if (this.candidateAssessmentFiles.length > 0) {
            let assessmentDocument;
            this.candidateAssessmentFiles.map(data => {
                if (data.name == type) {
                    assessmentDocument = data;
                }
            });
            return assessmentDocument.isSelected;
        }
        else {
            return false;
        }
    }
    _mapCandidateFieldsToReviewFormat() {
        // Mapping based on actual field names coming from the data
        const fieldMappingByName = {
            'Full Name': { key: 'FULL_NAME', label: 'Full Name' },
            'Phone Number': { key: 'PHONE_NUMBER', label: 'Phone Number' },
            'Email': { key: 'EMAIL', label: 'Email' },
            'Address': { key: 'ADDRESS', label: 'Address' },
            'Current Location': { key: 'CURRENT_LOCATION', label: 'Current Location' },
            'Current Role': { key: 'CURRENT_ROLE', label: 'Current Role' },
            'Current Company': { key: 'CURRENT_COMPANY', label: 'Current Company' },
            'Seeking Job Type': { key: 'SEEKING_JOB_TYPE', label: 'Seeking Job Type' },
            'Desired Salary/Rate': { key: 'DESIRED_SALARY_RATE', label: 'Desired Salary/Rate' },
            'Sponsorship': { key: 'SPONSORSHIP', label: 'Sponsorship' },
            'Willing To Relocate': { key: 'WILLING_TO_RELOCATE', label: 'Willing to Relocate' },
            'Willing to Relocate': { key: 'WILLING_TO_RELOCATE', label: 'Willing to Relocate' },
            'Linkedin Url': { key: 'LINKEDIN_URL', label: 'LinkedIn URL' },
            'LinkedIn URL': { key: 'LINKEDIN_URL', label: 'LinkedIn URL' }
        };
        // Fallback mapping by ID pattern for older data structure
        const fieldMappingById = {
            'name': { key: 'FULL_NAME', label: 'Full Name' },
            'phone_number': { key: 'PHONE_NUMBER', label: 'Phone Number' },
            'email': { key: 'EMAIL', label: 'Email' },
            'address': { key: 'ADDRESS', label: 'Address' },
            'current_location': { key: 'CURRENT_LOCATION', label: 'Current Location' },
            'current_role': { key: 'CURRENT_ROLE', label: 'Current Role' },
            'current_company': { key: 'CURRENT_COMPANY', label: 'Current Company' },
            'seeking_job_type': { key: 'SEEKING_JOB_TYPE', label: 'Seeking Job Type' },
            'desired_salary.rate': { key: 'DESIRED_SALARY_RATE', label: 'Desired Salary/Rate' },
            'sponsorship': { key: 'SPONSORSHIP', label: 'Sponsorship' },
            'willing_to_relocate': { key: 'WILLING_TO_RELOCATE', label: 'Willing to Relocate' },
            'linkedin_url': { key: 'LINKEDIN_URL', label: 'LinkedIn URL' }
        };
        const clientReviewIncludeFields = [];
        let displayOrder = 1; // Start from 1, increment based on selection order
        // Get selected fields - prefer emitted selectedFields, fallback to candidateInformationList
        let fieldsToProcess = this.selectedCandidateFieldsForReview;
        // Fallback: if no emitted fields, get selected fields from candidateInformationList
        if ((!fieldsToProcess || fieldsToProcess.length === 0) && this.candidateInformationList && this.candidateInformationList.length > 0) {
            fieldsToProcess = this.candidateInformationList.filter(c => c.selected);
        }
        if (fieldsToProcess && fieldsToProcess.length > 0) {
            fieldsToProcess.forEach((field, index) => {
                // Try mapping by name first (for actual candidate data)
                let fieldMap = fieldMappingByName[field.name];
                // Fallback to mapping by ID (for legacy data)
                if (!fieldMap) {
                    fieldMap = fieldMappingById[field.id];
                }
                // If no mapping found, generate one generically
                if (!fieldMap) {
                    // Generate fieldKey from field name (e.g., "Sponsorship Notes" -> "SPONSORSHIP_NOTES")
                    const generatedKey = (field.name || field.id)
                        .toUpperCase()
                        .replace(/\s+/g, '_')
                        .replace(/[/\-]/g, '_');
                    fieldMap = {
                        key: generatedKey,
                        label: field.name || field.id
                    };
                }
                const fieldValue = this._getFieldValue(field);
                clientReviewIncludeFields.push({
                    fieldKey: fieldMap.key,
                    fieldLabel: fieldMap.label,
                    fieldValue: fieldValue,
                    displayOrder: displayOrder // Use current displayOrder, then increment
                });
                displayOrder++; // Increment for next field
            });
        }
        return clientReviewIncludeFields;
    }
    _getFieldValue(field) {
        // Extract the actual field value, handling test values and empty strings
        if (!field || !field.value) {
            return 'Not Specified';
        }
        const valueStr = field.value.toString().trim();
        if (valueStr === '') {
            return 'Not Specified';
        }
        return valueStr;
    }
    _setEmailDetails() {
        const emailDetails = {
            candidateId: this.candidateId,
            userId: this.userId,
            candidateType: this.candidateDetails.candidateType,
            companyId: this.companyId,
            jobMatchId: this.candidateDetails.jobMatchId,
            candidateDocuments: {
                documents: this._setCandidateDocumentsToEmail(),
                sendResume: this._setCandidateResumesToEmail('Resume'),
                sendResumeHRXML: this._setCandidateResumesToEmail('Resume HR Xml')
            },
            jobMatchesDocuments: this._setJobMatchesDocumentsToEmail(),
            currentStep: this.candidateDetails.currentStep,
            emailDetails: {
                emailUsers: this.emailDetails.emailUsers,
                subject: this.emailDetails.subject,
                ccUsers: this.emailDetails.ccUsers,
                bccUsers: this.emailDetails.bccUsers,
                body: this.emailDetails.body
            }
        };
        // Add client review fields if "Send to Client for Review" is selected
        if (this.isSendForReviewSelected) {
            emailDetails.emailDetails.sentToClientForReview = true;
            emailDetails.emailDetails.clientReviewIncludeFields = this._mapCandidateFieldsToReviewFormat();
        }
        return emailDetails;
    }
    _checkIfMoreThanTwoCompanyEmailIdsExists() {
        let allClientOrBuNames = [];
        let allSelectedEmailTagObjects = [...this.selectedEmailSendToObjectsArray, ...this.selectedEmailCCObjectsArray, ...this.selectedEmailBCCObjectsArray];
        if (allSelectedEmailTagObjects.length > 1) {
            if (this.isStaffingCompany) {
                allSelectedEmailTagObjects.map(data => {
                    if (data.companyName) {
                        allClientOrBuNames.push(data.companyName);
                    }
                });
                // filter unique client names.
                let uniqueClientOrBuSet = new Set(allClientOrBuNames);
                return uniqueClientOrBuSet.size !== 1;
            }
            else {
                allSelectedEmailTagObjects.map(data => {
                    allClientOrBuNames.push(data.staffingCompany);
                });
                // filter unique bu names.
                let uniqueClientOrBuSet = new Set(allClientOrBuNames);
                return uniqueClientOrBuSet.size !== 1;
            }
        }
        else {
            return false;
        }
    }
    _checkIfNonCompanyEmailExists(emailDetails) {
        let allSelectedEmailTagObjects = [...this.selectedEmailSendToObjectsArray, ...this.selectedEmailCCObjectsArray, ...this.selectedEmailBCCObjectsArray];
        if (allSelectedEmailTagObjects.length > 0) {
            let nonCompanyEmailExists = false;
            allSelectedEmailTagObjects.map(data => {
                if (!data.id || data.id.toString().length < 3) {
                    nonCompanyEmailExists = true;
                }
            });
            return nonCompanyEmailExists;
        }
        else {
            return false;
        }
    }
    _sendMail(emailDetails) {
        this.savingFlag = true;
        this.documentService.emailDocuments(emailDetails, (data) => {
            this.alertsAndNotificationsService.showBannerMessage("Email sent successfully", "success");
            this.savingFlag = false;
            if (this.saveCallback) {
                this.saveCallback();
            }
        }, error => {
            this.savingFlag = false;
            this.alertsAndNotificationsService.showBannerMessage(error.message, "danger");
        });
    }
    sendMail() {
        this.emailDocumentsForm.$submitted = true;
        if (!this.emailDocumentsForm.$invalid) {
            // CRITICAL: Sync editor content to model before preparing email details
            this._syncEditorContentToModel();
            let emailDetails = this._setEmailDetails();
            if (this._checkIfMoreThanTwoCompanyEmailIdsExists(emailDetails) || this._checkIfNonCompanyEmailExists(emailDetails)) {
                this.savingFlag = true;
                let clientOrBu = this.$rootScope.userDetails.company.companyType == "Corporation" ? "BU" : "Client";
                let title = `Different ${clientOrBu}`;
                let message = `<div>
                                    <p>Email and/or document(s) being sent to email address(es) outside the company.<p>
                                    <p>Send anyway?</p>
                               </div>`;
                this.alertsAndNotificationsService.showConfirm(title, message, "warning", false, () => {
                    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                    this._sendMail(emailDetails);
                }, () => {
                    //do nothing
                    this.savingFlag = false;
                    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                });
            }
            else {
                this._sendMail(emailDetails);
            }
        }
    }
    cancel() {
        if (this.cancelCallback) {
            this.cancelCallback();
        }
    }
    /**
     * Syncs the editor DOM content back to the model to ensure all typed/edited content is captured
     */
    _syncEditorContentToModel() {
        const editorElem = document.querySelector('app-ngx-editor [contenteditable="true"]');
        if (editorElem && editorElem.innerHTML) {
            this.emailDetails.body = editorElem.innerHTML;
        }
    }
    attachDocuments(document) {
        let actionType = 'attachDocuments';
        let actionLabel = 'Attach Document';
        let windowTopClass = "four-dot-five-modal-large";
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        $(".modal").addClass("candidate-documents-modal");
        this.$timeout(() => {
            let candidateProfileActionsModal = this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                windowTopClass: windowTopClass,
                component: 'candidateProfileActionsModal',
                resolve: {
                    actionType: () => {
                        return actionType;
                    },
                    actionLabel: () => {
                        return actionLabel;
                    },
                    documents: () => {
                        return _.cloneDeep(this.attachedDocuments);
                    },
                    availableDocuments: () => {
                        return this.availableDocuments;
                    },
                    folders: () => {
                        return this.folders;
                    },
                    candidateJobMatchFolders: () => {
                        return this.candidateJobMatchFolders;
                    }
                }
            });
            candidateProfileActionsModal.result.then((callbackObject) => {
                if (callbackObject.entity && callbackObject.entity.length > 0) {
                    this.attachedDocuments = callbackObject.entity;
                    this._buildDocumentsSectionHtml();
                    // callbackObject.entity.forEach(doc => {
                    //     this.attachDocument(doc);
                    // });
                }
            }, (dismiss) => {
                //do nothing;
            });
        }, 300);
    }
    _setCandidateJobMatchFolders(jobMatches) {
        this.candidateJobMatchFolders = [];
        this.candidateJobMatchFolders = this.documentActionService.setCandidateJobMatchFolders(jobMatches, this.companyId, this.candidateId);
    }
    _setFolders(folders) {
        folders.forEach(folder => {
            folder.folders.forEach(subFolder => {
                subFolder.parentFolderId = folder.id;
                subFolder.parentFolderName = folder.name;
            });
        });
        this.folders = folders;
        this.documentActionService._setDocumentIcons(this.folders);
    }
    getAllCandidateFolders(response, successCallback) {
        let candidateType = this.candidateType ? this.candidateType : this.candidateDetails.candidateType;
        this.documentService.getAllCandidateFolders(this.candidateId, this.companyId, candidateType, (data) => {
            this._setFolders(data.candidateDocuments);
            if (this.candidateDetails && this.candidateDetails.context === 'candidateJobMatchCard') {
                let currentCandidateJobMatch = data.jobMatchesDocuments.filter(jobMatch => this.candidateDetails.jobMatchId == jobMatch.jobMatchId);
                this._setCandidateJobMatchFolders(currentCandidateJobMatch);
            }
            else {
                this._setCandidateJobMatchFolders(data.jobMatchesDocuments);
            }
            this.folders = this.documentActionService.setSharedFolderWithDocuments(this.folders, this.candidateId, this.companyId);
            let allDocuments = [];
            let parentDocuments = [];
            let childDocuments = [];
            this.folders.map(folder => {
                if (folder.name === 'Email Documents') {
                    this.emailDocumentFolderId = folder.id;
                }
                parentDocuments = [...folder.documents];
                childDocuments = [];
                folder.folders.forEach(subFolder => {
                    childDocuments = [...childDocuments, ...subFolder.documents];
                });
                allDocuments = [...allDocuments, ...parentDocuments, ...childDocuments];
            });
            //available documents
            this.availableDocuments = allDocuments;
            if (response) {
                // attached documents  
                response.map((document) => {
                    let index = _.findIndex(allDocuments, {
                        fileName: document.fileName
                    });
                    allDocuments[index].selected = true;
                    this.attachedDocuments.push(allDocuments[index]);
                });
            }
            else if (!this.documents || !this.document) {
                this.attachedDocuments = [];
            }
            if (this.candidateDetails.context != 'candidateJobMatchCard') {
                this._setUserToEmailSearchObject();
                // Pre populate users
                this._setPrePopulatedEmailUsersList();
            }
            this._buildDocumentsSectionHtml();
            if (successCallback) {
                successCallback();
            }
            this.isExistingDocumentsAvailable = true;
        }, error => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    addEmailDocumentFolder(successCallback) {
        let folder = {
            candidateId: this.candidateId,
            companyId: this.companyId,
            description: "Email Documents",
            name: "Email Documents",
            parentFolderId: null
        };
        this.documentService.addCandidateDocumentFolder(folder, (data) => {
            this.emailDocumentFolderId = data.id;
            if (successCallback) {
                successCallback();
            }
        }, error => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, "danger");
        });
    }
    openFileSelectionModal() {
        document.getElementById("emailDocumentUploadDropzone").click();
    }
    uploadEmailDocumentToUpload() {
        this.$timeout(() => {
            this.emailDocumentUploadDropzone.processQueue();
        }, 500);
    }
    attachDocumentsToEmail() {
        this.folders.map(folder => {
            if (folder.name === 'Email Documents') {
                this.emailDocumentFolderId = folder.id;
            }
        });
        if (this.emailDocumentFolderId) {
            this.openFileSelectionModal();
        }
        else {
            this.addEmailDocumentFolder(() => {
                this.openFileSelectionModal();
            });
        }
    }
    validateTypeAheadTags(tag) {
        if (!tag.id && !MESSAGECONSTANTS.VALIDATIONPATTERNS.EMAIL.test(tag.name)) {
            return null;
        }
        else {
            return tag;
        }
    }
    _setEmailNewTag(tag, type) {
        this.addedEmailCount += 1;
        let tempTag = { id: this.addedEmailCount, email: tag.email, displayString: "", name: tag.name, isNewTag: true };
        switch (type) {
            case 'emailUsers':
                this.selectedEmailSendToObjectsArray = this.selectedEmailSendToObjectsArray.filter(data => data.email != tag.email);
                this.selectedEmailSendToObjectsArray.push(tempTag);
                break;
            case 'ccUsers':
                this.selectedEmailCCObjectsArray = this.selectedEmailCCObjectsArray.filter(data => data.email != tag.email);
                ;
                this.selectedEmailCCObjectsArray.push(tempTag);
                break;
            case 'bccUsers':
                this.selectedEmailBCCObjectsArray = this.selectedEmailBCCObjectsArray.filter(data => data.email != tag.email);
                ;
                this.selectedEmailBCCObjectsArray.push(tempTag);
                break;
            default:
                break;
        }
        return tempTag;
    }
    emailTypeAheadAdded(tag, type) {
        if (!tag.id) {
            tag.email = tag.email ? tag.email : tag.name;
            let addNewTag = this._setEmailNewTag(tag, type);
            this.emailDetails[type].push({ email: addNewTag.email, name: addNewTag.name });
        }
        else {
            this.emailDetails[type].push(tag);
        }
        if ((!tag.id || !tag.staffingCompany) && !this.showClientForReviewCheckbox) {
            this.showClientForReviewCheckbox = true;
        }
    }
    emailTypeAheadRemoved(tag, type) {
        this.emailDetails[type] = this.emailDetails[type].filter(email => email.email != tag.email);
        this.checkIfNonStaffingCompanyUserExists(this.emailDetails);
    }
    checkIfNonStaffingCompanyUserExists(emailDetails) {
        this.showClientForReviewCheckbox = false;
        let EmailUsersFieldList = ['emailUsers', 'ccUsers', 'bccUsers'];
        for (let user of EmailUsersFieldList) {
            for (let data of emailDetails[user]) {
                if (!data.id || !data.staffingCompany) {
                    this.showClientForReviewCheckbox = true;
                    return;
                }
            }
        }
    }
    _setUserToEmailSearchObject() {
        this.searchUsersForEmail = {};
        this.searchUsersForEmail.email = "";
        this.searchUsersForEmail.firstName = "";
        this.searchUsersForEmail.lastName = "";
        this.searchUsersForEmail.onlyRequisitionUsers = this.isRequisitionUsersSelected;
        this.searchUsersForEmail.searchInCompanies = [];
        this.searchUsersForEmail.searchString = "";
        this.searchUsersForEmail.loggedInCompanyId = this.companyId;
        if (this.candidateDetails.context == 'candidateJobMatchCard') {
            let clientOrBuId = this.candidateDetails.clientOrBuId ? this.candidateDetails.clientOrBuId : this.companyId;
            this._setCompanyUserObject(clientOrBuId, this.candidateDetails.jobMatchRequisitionId, this.candidateDetails.jobMatchId);
        }
        else {
            if (this.candidateJobMatchFolders.length > 0) {
                this.candidateJobMatchFolders.map(candidateJobMatch => {
                    let clientOrBuId = candidateJobMatch.jobMatch.clientOrBuId ? candidateJobMatch.jobMatch.clientOrBuId : this.companyId;
                    this._setCompanyUserObject(clientOrBuId, candidateJobMatch.jobMatch.jobId, candidateJobMatch.jobMatch.jobMatchId);
                });
            }
        }
        if (this.searchUsersForEmail.searchInCompanies.length === 0) {
            this.searchUsersForEmail.searchInCompanies.push({
                companyOrClientBuId: this.companyId,
                loggedInCompanyId: this.companyId,
                vendorId: this.candidateDetails.vendorId ? this.candidateDetails.vendorId : null
            });
        }
    }
    _setCompanyUserObject(clientOrBuId, requisitionId, jobMatchId) {
        let companyUserObject = {
            companyOrClientBuId: this.companyId,
            requisitionId: requisitionId,
            jobMatchId: jobMatchId,
            loggedInCompanyId: this.companyId,
            vendorId: this.candidateDetails.vendorId ? this.candidateDetails.vendorId : null
        };
        this.searchUsersForEmail.searchInCompanies.push(companyUserObject);
        if (companyUserObject.companyOrClientBuId != clientOrBuId) {
            let clientUserObject = Object.assign({}, companyUserObject);
            clientUserObject.companyOrClientBuId = clientOrBuId;
            this.searchUsersForEmail.searchInCompanies.push(clientUserObject);
        }
    }
    _filterToCcBccExistingEmails(data, type) {
        let existingEmailArray = [];
        let existingEmailIds = [];
        if (type === 'to') {
            existingEmailArray = [...this.selectedEmailSendToObjectsArray];
        }
        else if (type === 'cc') {
            existingEmailArray = [...this.selectedEmailCCObjectsArray];
        }
        else if (type === 'bcc') {
            existingEmailArray = [...this.selectedEmailBCCObjectsArray];
        }
        if (existingEmailArray.length > 0) {
            existingEmailArray.map(val => existingEmailIds.push(val.email));
        }
        return data.filter(val => !existingEmailIds.includes(val.email));
    }
    getEmailIds(searchTerm, type) {
        let tempSearchUserForEmail = _.cloneDeep(this.searchUsersForEmail);
        if (tempSearchUserForEmail) {
            tempSearchUserForEmail.searchString = searchTerm;
            tempSearchUserForEmail.onlyRequisitionUsers = this.isRequisitionUsersSelected;
            if (!tempSearchUserForEmail.onlyRequisitionUsers) {
                tempSearchUserForEmail.searchInCompanies.map(data => {
                    data.requisitionId = null;
                });
            }
            return this.userService.getFilteredUsersToEmail(tempSearchUserForEmail).then((data) => {
                let filteredEmails = this._filterToCcBccExistingEmails(data, type);
                angular.forEach(filteredEmails, (val, key) => {
                    val.name = `${val.firstName ? val.firstName : ""} ${val.lastName ? val.lastName : ""}`;
                    val.displayString = `${val.firstName ? val.firstName : ""} ${val.lastName ? val.lastName : ""} (${val.email} ${val.companyName ? ", " + val.companyName : ""})`;
                    val.isCompanyUser = this._setCompanyUser(val);
                });
                return filteredEmails;
            });
        }
        else {
            return [];
        }
    }
    attach4dot5GeneratedDocuments(file) {
        // Updated when server side changes done
    }
    addNewEmployee() {
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        $(".modal").addClass("candidate-documents-modal");
        this.$timeout(() => {
            let candidateProfileActionsModal = this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                windowTopClass: 'four-dot-five-modal-medium',
                component: 'candidateProfileActionsModal',
                resolve: {
                    actionType: () => {
                        return 'addEmployee';
                    },
                    actionLabel: () => {
                        return 'Add Employee';
                    }
                }
            });
            candidateProfileActionsModal.result.then((callbackObject) => {
                //do nothing;
            }, (dismiss) => {
                //do nothing;
            });
        }, 300);
    }
    _setCandidateAssessmentReports() {
        if (this.candidateDetails && this.candidateDetails.resumeFileName && this.candidateDetails.resumeFileName != '') {
            this.candidateAssessmentFiles.push({ name: "Resume", fileName: "", isSelected: false, resumeNameOrXrXml: this.candidateDetails.resumeFileName });
            this.candidateAssessmentFiles.push({ name: "Resume HR Xml", fileName: "", isSelected: false, resumeNameOrXrXml: this.candidateDetails.resumeXRXml });
        }
    }
    _setEmailBodyPrePopulatedInformation(addCandidateInformation) {
        let prePopulatedEmailSignature = `<p><br/></p><p><br/></p><p><br/></p><p id="signature">Thank You!</p><p><b>${this.loggedInUserName}</b></p><br/><br/>`;
        this.emailDetails.body = prePopulatedEmailSignature;
        this.displayedBody = prePopulatedEmailSignature;
        // Update the actual editor DOM to keep it in sync with the model
        this.$timeout(() => {
            const editorElem = document.querySelector('.ta-bind');
            if (editorElem) {
                editorElem.innerHTML = this.emailDetails.body;
            }
        }, 100);
    }
    addTagOnTab(event, type) {
        if (event.originalEvent.keyCode == 9) {
            if (this.inputTypeAheadText[type] != '' && MESSAGECONSTANTS.VALIDATIONPATTERNS.EMAIL.test(this.inputTypeAheadText[type])) {
                event.preventDefault();
                let inputEmailText = this.inputTypeAheadText[type];
                let newTag = { id: null, email: inputEmailText, displayString: "", name: inputEmailText };
                this.emailTypeAheadAdded(newTag, type);
                this.inputTypeAheadText[type] = '';
            }
        }
    }
    _setPrePopulatedEmailUsersList(jobMatchId) {
        let jobMatchIdsArray = [];
        let jobMatchIds = "";
        if (jobMatchId) {
            jobMatchIdsArray.push(jobMatchId);
        }
        else {
            if (this.candidateJobMatchFolders.length > 0) {
                this.candidateJobMatchFolders.map(data => {
                    jobMatchIdsArray.push(data.jobMatch.jobMatchId);
                });
            }
        }
        jobMatchIds = jobMatchIdsArray.toString();
        this.userService.getUsersToPrePopulate(this.companyId, this.isRequisitionUsersSelected, jobMatchIds).then((data) => {
            let selectedUsersIds = this.selectedEmailSendToObjectsArray.length > 0 ? this.selectedEmailSendToObjectsArray.map(selectedEmail => { return selectedEmail.id; }) : this.selectedEmailSendToObjectsArray;
            data.map(prePopulatedUser => {
                if (prePopulatedUser && prePopulatedUser.id && !selectedUsersIds.includes(prePopulatedUser.id)) {
                    prePopulatedUser.name = `${prePopulatedUser.firstName ? prePopulatedUser.firstName : ""} ${prePopulatedUser.lastName ? prePopulatedUser.lastName : ""}`;
                    prePopulatedUser.isCompanyUser = this._setCompanyUser(prePopulatedUser);
                    if (this.selectedEmailCCObjectsArray.every(user => user.id != prePopulatedUser.id)) {
                        if (this.candidateDetails && this.candidateDetails.candidateEmail) {
                            this.selectedEmailCCObjectsArray.push(prePopulatedUser);
                            this.emailDetails.ccUsers.push(prePopulatedUser);
                        }
                        else {
                            this.selectedEmailSendToObjectsArray.push(prePopulatedUser);
                            this.emailDetails.emailUsers.push(prePopulatedUser);
                        }
                    }
                }
                if (prePopulatedUser && !prePopulatedUser.staffingCompany) {
                    this.showClientForReviewCheckbox = true;
                }
            });
            this.isPrePopulatedUsersAvailable = true;
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, "danger");
            this.isPrePopulatedUsersAvailable = true;
        });
    }
    _setCompanyUser(prePopulatedUser) {
        let isCompanyUser = false;
        if (!this.isStaffingCompany) {
            if (prePopulatedUser.staffingCompany) {
                isCompanyUser = true;
            }
        }
        else {
            isCompanyUser = prePopulatedUser.staffingCompany;
        }
        return isCompanyUser;
    }
    getCustomTagClass(tag) {
        if (tag.isNewTag) {
            return 'new-email-user-tag';
        }
        else {
            if (this.isStaffingCompany) {
                if (tag && !tag.isCompanyUser) {
                    return 'other-company-user-tag';
                }
            }
            else {
                if (tag && tag.isCompanyUser) {
                    return 'other-company-user-tag';
                }
            }
        }
    }
    onTagClicked(tag) {
        if (tag.name == tag.email) {
            if (tag.id && (tag.firstName || tag.lastName)) {
                tag.name = tag.originalName.slice();
            }
        }
        else {
            tag.originalName = tag.name;
            tag.name = tag.email;
        }
    }
    getCustomAutoCompleteClass(match, selected) {
        if (match) {
            if (this.isStaffingCompany) {
                if (!match.isCompanyUser && selected == false) {
                    return 'other-company-auto-complete-user-tag';
                }
                else if (!match.isCompanyUser && selected == true) {
                    return 'other-company-auto-complete-user-tag-selected';
                }
            }
            else {
                if (match.isCompanyUser && selected == false) {
                    return 'other-company-auto-complete-user-tag';
                }
                else if (match.isCompanyUser && selected == true) {
                    return 'other-company-auto-complete-user-tag-selected';
                }
            }
        }
    }
    viewDocumentFIle(file) {
        this.sharedAjsService.viewDocumentFIle(file, (data) => {
        }, (error) => {
        });
    }
    _handleFilterDisplay() {
        $(document).ready(() => {
            const panel = $("#candidate-information-panel");
            const chevronDown = $("#open-candidate-information-filter .fa-chevron-down");
            const chevronUp = $("#open-candidate-information-filter .fa-chevron-up");
            // Initially hide panel and set icon state
            panel.hide();
            chevronUp.hide();
            chevronDown.show();
            // Remove old handlers to avoid duplicates
            $(document)
                .off("click", "#open-candidate-information-filter")
                .on("click", "#open-candidate-information-filter", () => {
                // Toggle the panel
                panel.animate({ height: "toggle" }, 200, () => {
                    // After animation completes, toggle icon visibility
                    if (panel.is(":visible")) {
                        chevronDown.hide();
                        chevronUp.show();
                    }
                    else {
                        chevronUp.hide();
                        chevronDown.show();
                    }
                });
            });
        });
    }
    _setCandidateInformationInBody() {
        this.candidateInformationList = [];
        let candidateInformation = ['name', 'phone_number', 'email', 'address', 'current_location', 'current_role', 'current_company', 'seeking_job_type', 'desired_salary.rate', 'sponsorship', 'willing_to_relocate', 'linkedin_url'];
        candidateInformation.map(candidate => {
            let name = candidate.split('_');
            let formattedName = name.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
            formattedName = formattedName.replace('.', '/');
            let tempObj = { id: candidate, name: formattedName, value: 'Test' + candidate, selected: false };
            this.candidateInformationList.push(tempObj);
        });
    }
    addCandidateInformationToBody(candidate) {
        if (candidate.selected) {
            const paragraphToInsert = this._setCandidateInfoInParagraph(this.emailDetails.body, candidate);
            let originalString = this.emailDetails.body;
            let signatureIndex = originalString.indexOf(`<p id="signature">`);
            if (signatureIndex !== -1) {
                this.emailDetails.body =
                    originalString.slice(0, signatureIndex) +
                        paragraphToInsert +
                        originalString.slice(signatureIndex);
            }
            else {
                this.emailDetails.body += paragraphToInsert;
            }
        }
        else {
            // Remove paragraph when unchecked
            const tempElement = document.createElement('div');
            tempElement.innerHTML = this.emailDetails.body;
            const pToRemove = tempElement.querySelector(`span[id="${candidate.id}"]`);
            if (pToRemove) {
                pToRemove.parentNode.removeChild(pToRemove);
            }
            this.emailDetails.body = tempElement.innerHTML;
        }
        // CRITICAL: Update the actual editor DOM to keep it in sync with the model
        this.$timeout(() => {
            const editorElem = document.querySelector('.ta-bind');
            if (editorElem) {
                editorElem.innerHTML = this.emailDetails.body;
            }
        }, 50);
    }
    _setCandidateInfoInParagraph(body, candidate) {
        // Creates a simple editable paragraph
        const paragraph = `<span id="${candidate.id}" contenteditable="true">
        <b>${candidate.name}:</b> ${candidate.value || 'Not Specified'}
    </span>`;
        return paragraph;
    }
    selectAllCandidateInformation(selectAll) {
        if (!this.candidateInformationList || this.candidateInformationList.length === 0)
            return;
        this.candidateInformationList.forEach(candidate => {
            candidate.selected = selectAll;
            this.addCandidateInformationToBody(candidate);
        });
    }
    // onEmailBodyChange() {
    //     if (!this.emailDetails.body || this.emailDetails.body.trim() === '') return;
    //     let tempDiv = document.createElement('div');
    //     tempDiv.innerHTML = this.emailDetails.body;
    //     let shouldUpdate = false;
    //     this.candidateInformationList.forEach(candidate => {
    //         const pElement = tempDiv.querySelector(`p[id="${candidate.id}"]`);
    //         if (!pElement || pElement.innerText.trim() === '') {
    //             if (candidate.selected) candidate.selected = false;
    //             if (pElement) pElement.remove();
    //             shouldUpdate = true;
    //         }
    //     });
    //     if (shouldUpdate) {
    //         // Small delay lets Rangy finish restoring before updating model
    //         setTimeout(() => {
    //             this.emailDetails.body = tempDiv.innerHTML;
    //         }, 50);
    //     }
    // }
    onEmailBodyChange() {
        const editorElem = document.querySelector('.ta-bind');
        if (!editorElem)
            return;
        this.candidateInformationList.forEach(candidate => {
            const p = editorElem.querySelector(`p[id="${candidate.id}"]`);
            if (p && p.innerText.trim() === '') {
                candidate.selected = false;
                p.remove();
            }
        });
    }
    emailContentChange(event) {
        this.emailDetails.body = event;
        this.displayedBody = event;
        // Sync document checkboxes when the documents section is manually removed from the editor.
        const editorElem = document.querySelector('app-ngx-editor [contenteditable="true"]');
        let hasDocSection;
        if (editorElem) {
            const docSection = editorElem.querySelector('#email-documents-section');
            const docHeader = editorElem.querySelector('#doc-attach-header');
            // Consider the section present only if it (or its header) has non-empty visible text.
            hasDocSection = (!!docSection && docSection.textContent.trim() !== '') ||
                (!!docHeader && docHeader.textContent.trim() !== '');
        }
        else {
            hasDocSection = event.includes('id="doc-attach-header"') || event.includes("id='doc-attach-header'");
        }
        if (!hasDocSection) {
            const hasSelectedDocs = (this.attachedDocuments && this.attachedDocuments.length > 0) ||
                (this.candidateAssessmentFiles || []).some(f => f.isSelected);
            if (hasSelectedDocs) {
                if (this.candidateAssessmentFiles) {
                    this.candidateAssessmentFiles.forEach(f => { f.isSelected = false; });
                }
                this.attachedDocuments = [];
                this.documentsSectionHtml = '';
            }
        }
    }
    onSelectedFieldsChange(selectedFields) {
        // Enrich selected fields with actual values from candidateInformationList
        this.selectedCandidateFieldsForReview = selectedFields.map(field => {
            // Try to find the original field in candidateInformationList to get more complete data
            const originalField = this.candidateInformationList.find(c => c.id === field.id);
            if (originalField) {
                return {
                    id: field.id,
                    name: field.name || originalField.name,
                    value: originalField.value || field.value,
                    selected: true
                };
            }
            return field;
        });
    }
    /**
     * Called when the Angular email-html-editor emits candidateSelectionSync.
     */
    onCandidateSelectionSync(updatedList) {
        if (!updatedList || !this.candidateInformationList)
            return;
        updatedList.forEach(updated => {
            const local = this.candidateInformationList.find(c => c.id === updated.id);
            if (local) {
                local.selected = updated.selected;
            }
        });
        this.selectAllCandidatesExternal = this.candidateInformationList.every(c => c.selected);
        // Replace array reference so AngularJS one-time / ng-repeat re-evaluates
        this.candidateInformationList = [...this.candidateInformationList];
    }
    onExternalSelectAll(checked) {
        this.selectAllCandidatesExternal = checked;
        if (this.candidateInformationList) {
            this.candidateInformationList.forEach(c => c.selected = checked);
        }
        this.externalCandidateAction = { type: 'selectAll', selectAll: checked, timestamp: Date.now() };
    }
    onExternalCandidateToggle(candidate) {
        this.externalCandidateAction = { type: 'single', candidate: candidate, timestamp: Date.now() };
        // sync selectAllCandidatesExternal
        if (this.candidateInformationList) {
            this.selectAllCandidatesExternal = this.candidateInformationList.every(c => c.selected);
        }
    }
    adjustAttachedDocumentsHeight() {
        const $emailFormSection = $('#emailFormSection');
        const $attachDocumentsSection = $('#attachDocumentsSection');
        const $otherDocumentsSection = $('#otherDocumentsSection');
        const $loadingSpinner = $('#loadingSpinner');
        if ($emailFormSection.length === 0 || $attachDocumentsSection.length === 0) {
            return;
        }
        const updateHeight = () => {
            const emailFormHeight = $emailFormSection.outerHeight();
            if (emailFormHeight > 0) {
                // Remove max-height from attachDocumentsSection
                $attachDocumentsSection.css('max-height', 'none');
                $attachDocumentsSection.css('overflow-y', 'visible');
                // Calculate the height used by other elements in attachDocumentsSection
                const attachDocumentsSectionHeight = $attachDocumentsSection.outerHeight();
                // Calculate remaining height for otherDocumentsSection
                const remainingHeight = emailFormHeight - 110;
                if (remainingHeight > 100) {
                    $otherDocumentsSection.css('max-height', remainingHeight + 'px');
                    $loadingSpinner.css('max-height', remainingHeight + 'px');
                }
                else {
                    $otherDocumentsSection.css('max-height', '100px');
                    $loadingSpinner.css('max-height', '100px');
                }
            }
        };
        // Initial height adjustment with delay
        this.$timeout(() => {
            updateHeight();
        }, 100);
        this.$timeout(() => {
            updateHeight();
        }, 500);
        // Observe changes
        const observer = new MutationObserver(() => {
            updateHeight();
        });
        observer.observe($emailFormSection[0], {
            attributes: true,
            childList: true,
            subtree: true,
            characterData: true
        });
        // Also observe window resize
        $(window).on('resize', updateHeight);
        // Cleanup component
        this.$rootScope.$on('$destroy', () => {
            observer.disconnect();
            $(window).off('resize', updateHeight);
        });
    }
}
EmailDocumentsController.$inject = ['$rootScope', '$timeout', '$uibModal', 'modalService', 'documentService', 'alertsAndNotificationsService', 'documentActionService', 'userService', 'jobMatchService', 'sharedAjsService', 'llmIntegrationService'];
// import * as TEMPLATE from './email-documents.html';
import * as TEMPLATE from 'raw-loader!./email-documents.html';
export const EmailDocumentsComponent = {
    selector: 'emailDocuments',
    component: {
        bindings: {
            context: '@',
            document: '<',
            documents: '<',
            candidateDetails: '<',
            folders: '<',
            candidateJobMatchFolders: '<',
            hasResume: '<',
            saveCallback: '&',
            cancelCallback: '&',
            sourceScreen: '@',
            formalizeActivityPayload: '<'
        },
        controller: EmailDocumentsController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/candidateprofile/candidateProfile/candidateDocuments/emailDocuments/email-documents.html'
    }
};
//# sourceMappingURL=email-documents.component.js.map